import React, { FC } from 'react';
import { styled } from '@mui/material/styles';
import { useCrispChat } from '../../../services/crisp/useCrispChat';
import { CAV6 } from '../cav6tokens';
import { BODY_FONT, t, TICKET } from '../HomeScreen/HomeScreen.styles';
import { useTrackEvent } from '../../../common/hooks/useTrackEvent';
import { EventNames } from '../../../common/constants/constants';
import { useTypedSelector } from '../../../store/store';
import { selectUploadPhase } from '../../../services/upload/uploadPhase';

// Sits in the ticket's foot section (UploadTicket).
const Pill = styled('button')({
  appearance: 'none',
  margin: '0 auto',
  background: '#ececec',
  borderRadius: CAV6.pillRadius,
  minHeight: CAV6.supportPillH,
  padding: '10px 22px',
  color: '#5c6064',
  fontSize: t(16),
  fontFamily: BODY_FONT,
  border: '1px solid rgba(0,0,0,.08)',
  boxShadow: '0 1px 2px rgba(0,0,0,.05)',
  display: 'inline-flex',
  gap: '6px',
  alignItems: 'center',
  justifyContent: 'center',
  whiteSpace: 'nowrap',
  cursor: 'pointer',
  userSelect: 'none',
  WebkitTapHighlightColor: 'transparent',
  '& span': { fontSize: 'max(13px, 1em)' },
});

const LiveText = styled('span')({
  fontWeight: 600,
  textDecoration: 'underline',
  textUnderlineOffset: '3px',
  color: TICKET.labelInk,
});

export const SupportPill: FC = () => {
  const { openCrispChat, showCrispChat } = useCrispChat();
  const { trackEvent } = useTrackEvent();
  const phase = useTypedSelector(selectUploadPhase);
  const uploadPct = useTypedSelector((state) => state.upload.uploadingProgress);

  const handleClick = () => {
    trackEvent({
      action: EventNames.support_pill_click,
      screen: 'upload_flow',
      upload_state: phase,
      upload_pct: uploadPct,
    });
    // Ensure Crisp widget is visible first, then open the chat
    showCrispChat();
    openCrispChat();
  };

  return (
    <Pill type="button" onClick={handleClick} aria-label="Having trouble? Live chat">
      <span>Having trouble?</span>
      <LiveText>Live chat</LiveText>
    </Pill>
  );
};
